import { AppState } from '../../../state/index';
export const getTenantList = (state: AppState) => state.tenant;